import React from "react";
import CocktailList from "../components/CocktailList";
import SearchBar from "../components/SearchBar";
const Home = () => {
  return (
    <>
      <SearchBar />
      <CocktailList />
    </>
  );
};

export default Home;
